<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Add Resource'"
    :submit-button-text="'UPLOAD'"
    :submit-disabled="!file"
    :reset-modal="resetModal"
    :submit-modal="addResource"
  >
    <p class="tsny_text">
      Select a resource to add to your course. Be advised that we don't prevent
      duplicate uploads.
    </p>
    <b-form enctype="multipart/form-data">
      <b-form-file
        v-model="file"
        class="tsny_text"
        placeholder="Give us them sweet, sweet resources"
      />
    </b-form>
    <p v-if="resourceUploadError" class="tsny_text">
      Something went wrong uploading your resource. Go harass your dev
    </p>
  </tsny-modal>
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";
import TsnyModal from "../TsnyModal";

export default {
  name: "UploadResource",
  components: { tsnyModal: TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    resources: {
      type: Array,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "addResourceModal",
      file: null,
      resourceUploadError: false
    };
  },
  methods: {
    addResource: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.resourceUploadError = false;

      let formData = new FormData();

      formData.append("file", $comp.file);
      formData.append("courseId", $comp.courseId);

      return CourseRestService.addResources(formData)
        .then(response => {
          let data = response.data || {};
          $comp.resources.push(data);
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          console.log(err);
          $comp.resourceUploadError = true;
        });
    },
    resetModal: function() {
      this.file = null;
      this.resourceUploadError = false;
    }
  }
};
</script>

<style scoped></style>
